import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

// Define ClassValue type locally to avoid the "type" import syntax
type ClassValue =
  | string
  | number
  | boolean
  | undefined
  | null
  | { [key: string]: any }
  | ClassValue[]

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs))
}

export function formatDate(input: string | number): string {
  const date = new Date(input)
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
}

export function absoluteUrl(path: string) {
  return `${process.env.NEXT_PUBLIC_APP_URL}${path}`
}
